import { render } from "./view.vue?vue&type=template&id=efb39978&ts=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Promotors/view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "efb39978"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('efb39978', __exports__)) {
    api.reload('efb39978', __exports__)
  }
  
  module.hot.accept("./view.vue?vue&type=template&id=efb39978&ts=true", () => {
    api.rerender('efb39978', render)
  })

}


export default __exports__